/**
 * 全局数据模型
 */

export default {
  initing: true,
  /**用户信息 */
  userInfo: {
    avatar: "",
    nickname: "",
    uuid: "",
    ticket: "",
    mobile: "",
  },
  activityId: 39,
};
